// =====================================================================================================================
// BUTTON VIEW
//
//  The button we use on the projects area of the website.
//

import { EventManager, HorizContainer, Ui} from "@stratisopt/platform";
import { UiFactory } from "@stratisopt/platform";

export class ButtonView extends HorizContainer {

    // =================================================================================================================
    // CONSTRUCTORS
    //

    // Create and initialize a new instance
    public static create(json:any):ButtonView {
        let ui = new ButtonView();
        ui.init(json);
        return ui;
    }

    // Initialize this instance
    public init(json:any) {

        // Mine out nav item specific properties
        const value = json.value;
        const touchAction = json.touchAction;

        if (value === undefined)
            EventManager.publish(this.constructor.name, "Warning: No \"value\" provided for the ButtonView");

        if (touchAction === undefined)
            EventManager.publish(this.constructor.name, "Warning: No \"touchAction\" provided for the ButtonView");


        let newJson = this.createJson(value, touchAction);

        // Initialize the super
        super.init(newJson);
        UiFactory.addChildren(this, newJson);

        // Update with json overrides (if they exist)
        if (json !== undefined) {
            this.setFieldsFromJson(json);           
        }
    }


    // =================================================================================================================
    // VIEW
    //

    private createJson(value:string = "No text given", touchAction = ""):any {

        let json:any = {
            margin:Ui.theme.SPACING_Nest,
            textColor:Ui.theme.COLOR_FontNeutral,
            cursor:'pointer', effect:'hover',
            children:[
                {type:'text', pad:Ui.theme.SPACING_Neutral, backColor:Ui.theme.COLOR_ProjectButton, borderRadius:Ui.theme.BORDER_Rounded, 
                    onTouch:touchAction, 
                    value:value
                }
            ]   
        };
        return json;
    }

}
